/* eslint-disable max-lines */
import { IAssessmentResponsesPayload } from '../../../../pages/Dashboard/DashboardCover/DiscoverAssess/DiscoverAssess';
import { ICSPAssessQuestionnaireListItem, IDAQuestionnaireListItem, IPlanCardContent } from '../../../models/DashboardModels';
import {
  ICSPAssessQuestionnaireRequestPayload,
  IDAQAnswersResponsePayload,
  IDAQuestionnaireResponsePayload,
  IPlanCapabilityRequestPayload,
  ISecurityAssessmentGetObj,
  IUploadAssessmentState,
} from '../../../models/DevopsAnalyticsModels';
import {
  IAssessmentQuestionsResponse,
  IAssessmentResponse,
  IAssessmentResultPayload,
  ICloudHealthDataResponse,
  IDevOpsChartValues,
  IDevopsDataResponse,
  IGovAnalysisDataResponse,
  IGovDataType,
} from '../../state/DevOpsAnalyticsState';
import { IStoreAction } from '../../StoreHelper';

export enum DevOpsAnalyticsActionTypes {
  GET_ANALYTICS_ASSESSMENT_START = 'GET_ANALYTICS_ASSESSMENT_START',
  GET_ANALYTICS_ASSESSMENT_SUCCESS = 'GET_ANALYTICS_ASSESSMENT_SUCCESS',
  GET_ANALYTICS_ASSESSMENT_ERROR = 'GET_ANALYTICS_ASSESSMENT_ERROR',
  GET_GOVERNANCE_ASSESSMENT_START = 'GET_GOVERNANCE_ASSESSMENT_START',
  GET_GOVERNANCE_ASSESSMENT_SUCCESS = 'GET_GOVERNANCE_ASSESSMENT_SUCCESS',
  GET_GOVERNANCE_ASSESSMENT_ERROR = 'GET_GOVERNANCE_ASSESSMENT_ERROR',
  POST_GOVERNANCE_ASSESSMENT_START = 'POST_GOVERNANCE_ASSESSMENT_START',
  POST_GOVERNANCE_ASSESSMENT_SUCCESS = 'POST_GOVERNANCE_ASSESSMENT_SUCCESS',
  POST_GOVERNANCE_ASSESSMENT_ERROR = 'POST_GOVERNANCE_ASSESSMENT_ERROR',
  GET_ASSESSMENT_QUESTIONS_START = 'GET_ASSESSMENT_QUESTIONS_START',
  GET_ASSESSMENT_QUESTIONS_SUCCESS = 'GET_ASSESSMENT_QUESTIONS_SUCCESS',
  GET_ASSESSMENT_QUESTIONS_ERROR = 'GET_ASSESSMENT_QUESTIONS_ERROR',
  SET_ASSESSMENT_RESULT_START = 'SET_ASSESSMENT_RESULT_START',
  SET_ASSESSMENT_RESULT_SUCCESS = 'SET_ASSESSMENT_RESULT_SUCCESS',
  SET_ASSESSMENT_RESULT_ERROR = 'SET_ASSESSMENT_QUESTIONS_ERROR',
  GET_BUILD_DEPLOY_ASSESSMENT_START = 'GET_BUILD_DEPLOY_ASSESSMENT_START',
  GET_BUILD_DEPLOY_ASSESSMENT_SUCCESS = 'GET_BUILD_DEPLOY_ASSESSMENT_SUCCESS',
  GET_BUILD_DEPLOY_ASSESSMENT_ERROR = 'GET_BUILD_DEPLOY_ASSESSMENT_ERROR',

  GET_SECURITY_ASSESSMENT_GRAPH_DATA_START = 'GET_SECURITY_ASSESSMENT_GRAPH_DATA_START',
  GET_SECURITY_ASSESSMENT_GRAPH_DATA_SUCCESS = 'GET_SECURITY_ASSESSMENT_GRAPH_DATA_SUCCESS',
  GET_SECURITY_ASSESSMENT_GRAPH_DATA_ERROR = 'GET_SECURITY_ASSESSMENT_GRAPH_DATA_ERROR',

  GET_DISCOVER_ASSESSMENT_GRAPH_START = 'GET_DISCOVER_ASSESSMENT_GRAPH_START',
  GET_DISCOVER_ASSESSMENT_GRAPH_SUCCESS = 'GET_DISCOVER_ASSESSMENT_GRAPH_SUCCESS',
  GET_DISCOVER_ASSESSMENT_GRAPH_ERROR = 'GET_DISCOVER_ASSESSMENT_GRAPH_ERROR',

  GET_ASSESSMENT_RESPONSES_START = 'GET_ASSESSMENT_RESPONSES_START',
  GET_ASSESSMENT_RESPONSES_SUCCESS = 'GET_ASSESSMENT_RESPONSES_SUCCESS',
  GET_ASSESSMENT_RESPONSES_ERROR = 'GET_ASSESSMENT_RESPONSES_ERROR',

  GET_DISCOVERY_ASS_QUESTIONS_START = 'GET_DISCOVERY_ASS_QUESTIONS_START',
  GET_DISCOVERY_ASS_QUESTIONS_SUCCESS = 'GET_DISCOVERY_ASS_QUESTIONS_SUCCESS',
  GET_DISCOVERY_ASS_QUESTIONS_ERROR = 'GET_DISCOVERY_ASS_QUESTIONS_ERROR',

  SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_START = 'SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_START',
  SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_SUCCESS = 'SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_SUCCESS',
  SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_ERROR = 'SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_ERROR',

  UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_START = 'UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_START',
  UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_SUCCESS = 'UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_SUCCESS',
  UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_ERROR = 'UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_ERROR',

  RESET_ANS_FLAG = 'RESET_ANS_FLAG',

  GET_CSP_ASSES_QUESTIONS_START = 'GET_CSP_ASSES_QUESTIONS_START',
  GET_CSP_ASSES_QUESTIONS_SUCCESS = 'GET_CSP_ASSES_QUESTIONS_SUCCESS',
  GET_CSP_ASSES_QUESTIONS_ERROR = 'GET_CSP_ASSES_QUESTIONS_ERROR',

  SUBMIT_SAVE_CSP_ASSES_QUESTIONS_START = 'SUBMIT_SAVE_CSP_ASSES_QUESTIONS_START',
  SUBMIT_SAVE_CSP_ASSES_QUESTIONS_SUCCESS = 'SUBMIT_SAVE_CSP_ASSES_QUESTIONS_SUCCESS',
  SUBMIT_SAVE_CSP_ASSES_QUESTIONS_ERROR = 'SUBMIT_SAVE_CSP_ASSES_QUESTIONS_ERROR',

  GET_PLAN_CAPABILITY_LIST_START = 'GET_PLAN_CAPABILITY_LIST_START',
  GET_PLAN_CAPABILITY_LIST_SUCCESS = 'GET_PLAN_CAPABILITY_LIST_SUCCESS',
  GET_PLAN_CAPABILITY_LIST_ERROR = 'GET_PLAN_CAPABILITY_LIST_ERROR',

  SAVE_PLAN_CAPABILITY_LIST_START = 'SAVE_PLAN_CAPABILITY_LIST_START',
  SAVE_PLAN_CAPABILITY_LIST_SUCCESS = 'SAVE_PLAN_CAPABILITY_LIST_SUCCESS',
  SAVE_PLAN_CAPABILITY_LIST_ERROR = 'SAVE_PLAN_CAPABILITY_LIST_ERROR',
}

export type DevOpsAnalyticsActionPayload =
  | Error
  | IDevOpsChartValues[]
  | IDevopsDataResponse
  | string
  | IUploadAssessmentState
  | IGovAnalysisDataResponse
  | IAssessmentQuestionsResponse[]
  | IGovDataType
  | ISecurityAssessmentGetObj
  | IAssessmentResultPayload
  | ICloudHealthDataResponse
  | IAssessmentResponsesPayload
  | IAssessmentResponse
  | IDAQuestionnaireResponsePayload
  | boolean
  | IDAQuestionnaireListItem[]
  | IDAQAnswersResponsePayload
  | ICSPAssessQuestionnaireListItem[]
  | ICSPAssessQuestionnaireRequestPayload
  | IPlanCardContent[]
  | IPlanCapabilityRequestPayload

export type DevOpsAnalyticsAction = IStoreAction<
  DevOpsAnalyticsActionTypes,
  DevOpsAnalyticsActionPayload
>;

export class DevOpsAnalyticsActions {
  public static getAnalyticsAssessmentStart(data: string): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_START,
      data,
    };
  }
  public static getAnalyticsAssessmentSuccess(data: IDevopsDataResponse): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_SUCCESS,
      data,
    };
  }

  public static getAnalyticsAssessmentError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ANALYTICS_ASSESSMENT_ERROR,
      data: error,
    };
  }
  public static getGovernanceAssessmentStart(data: string): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_START,
      data,
    };
  }
  public static getGovernanceAssessmentSuccess(
    data: IGovAnalysisDataResponse,
  ): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_SUCCESS,
      data,
    };
  }
  public static getGovernanceAssessmentError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_GOVERNANCE_ASSESSMENT_ERROR,
      data: error,
    };
  }

  public static getBuildDeployAssessmentStart(data: string): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_START,
      data,
    };
  }
  public static getBuildDeployAssessmentSuccess(
    data: IGovAnalysisDataResponse,
  ): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_SUCCESS,
      data,
    };
  }
  public static getBuildDeployAssessmentError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_BUILD_DEPLOY_ASSESSMENT_ERROR,
      data: error,
    };
  }

  public static getSecurityGovernanceAssessmentDataStart(
    data: ISecurityAssessmentGetObj,
  ): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_START,
      data,
    };
  }
  public static getSecurityGovernanceAssessmentDataSuccess(
    data: IGovAnalysisDataResponse,
  ): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_SUCCESS,
      data,
    };
  }
  public static getSecurityGovernanceAssessmentDataError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_SECURITY_ASSESSMENT_GRAPH_DATA_ERROR,
      data: error,
    };
  }

  public static postGovernanceAssessmentStart(data: IUploadAssessmentState): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_START,
      data,
    };
  }

  public static postGovernanceAssessmentSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_SUCCESS,
    };
  }

  public static postGovernanceAssessmentError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.POST_GOVERNANCE_ASSESSMENT_ERROR,
      data: error,
    };
  }
  public static getAssessmentQuestionsStart(data: string): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_START,
      data,
    };
  }
  public static getAssessmentQuestionsSuccess(
    data: IAssessmentQuestionsResponse[],
  ): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_SUCCESS,
      data,
    };
  }

  public static getAssessmentQuestionsError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_QUESTIONS_ERROR,
      data: error,
    };
  }
  public static setAssessmentResultStart(data: IAssessmentResultPayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_START,
      data,
    };
  }

  public static setAssessmentResultSSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_SUCCESS,
    };
  }

  public static setAssessmentResultError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SET_ASSESSMENT_RESULT_ERROR,
      data: error,
    };
  }

  public static getDiscoverAssessmentStart(data: ISecurityAssessmentGetObj): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_START,
      data,
    };
  }
  public static getDiscoverAssessmentSuccess(data: IDevopsDataResponse): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_SUCCESS,
      data,
    };
  }
  public static getDiscoverAssessmentError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVER_ASSESSMENT_GRAPH_ERROR,
      data: error,
    };
  }

  // Getting Assessment responses filled by user for cloud foundation strategy
  public static getAssessmentResponsesStart(data: IAssessmentResponsesPayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_START,
      data,
    };
  }
  public static getAssessmentResponsesSuccess(data: IAssessmentResponse): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_SUCCESS,
      data,
    };
  }
  public static getAssessmentResponsesError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_ASSESSMENT_RESPONSES_ERROR,
      data: error,
    };
  }

  // Assessment for Discovery and Assessment questionnaire
  public static getDiscAssessQuestionListStart(data: IDAQuestionnaireResponsePayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_START,
      data,
    };
  }
  public static getDiscAssessQuestionListSuccess(data: IDAQuestionnaireListItem[]): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_SUCCESS,
      data,
    };
  }
  public static getDiscAssessQuestionListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_DISCOVERY_ASS_QUESTIONS_ERROR,
      data: error,
    };
  }

  // Submit Answers
  public static saveSubmitDiscAssessQuestionListStart(data: IDAQAnswersResponsePayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_START,
      data,
    };
  }
  public static saveSubmitDiscAssessQuestionListSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_SUCCESS,
    };
  }
  public static saveSubmitDiscAssessQuestionListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_DISCOVERY_ASS_QUESTIONS_ERROR,
      data: error,
    };
  }

  // Update Answers
  public static updateDiscAssessQuestionListStart(data: IDAQAnswersResponsePayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_START,
      data,
    };
  }
  public static updateDiscAssessQuestionListSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_SUCCESS,
    };
  }
  public static updateDiscAssessQuestionListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.UPDATE_ANS_DISCOVERY_ASS_QUESTIONS_ERROR,
      data: error,
    };
  }

  // reset flag
  public static resetDiscAssessQuestionSubmissionSuccessfull(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.RESET_ANS_FLAG,
    };
  }

  // GET ASSESS LIST
  public static getCspAssessQuestionListStart(data: IDAQuestionnaireResponsePayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_START,
      data,
    };
  }
  public static getCspAssessQuestionListSuccess(data: ICSPAssessQuestionnaireListItem[]): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_SUCCESS,
      data,
    };
  }
  public static getCspAssessQuestionListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_CSP_ASSES_QUESTIONS_ERROR,
      data: error,
    };
  }

  // SUBMIT ASSESS ANSWERS
  public static submitCspAssessStart(data: ICSPAssessQuestionnaireRequestPayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_START,
      data,
    };
  }
  public static submitCspAssessSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_SUCCESS,
    };
  }
  public static submitCspAssessError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SUBMIT_SAVE_CSP_ASSES_QUESTIONS_ERROR,
      data: error,
    };
  }

  // GET CAPABILITIES UNDER PLAN TAB
  public static getPlanCapabilityListStart(data: string): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_START,
      data,
    };
  }
  public static getPlanCapabilityListSuccess(data: IPlanCardContent[]): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_SUCCESS,
      data,
    };
  }
  public static getPlanCapabilityListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.GET_PLAN_CAPABILITY_LIST_ERROR,
      data: error,
    };
  }

  // SAVE DATA FOR CAPABILITIES UNDER PLAN TAB
  public static savePlanListStart(data: IPlanCapabilityRequestPayload): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_START,
      data,
    };
  }
  public static savePlanListSuccess(): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_SUCCESS,
    };
  }
  public static savePlanListError(error: Error): DevOpsAnalyticsAction {
    return {
      type: DevOpsAnalyticsActionTypes.SAVE_PLAN_CAPABILITY_LIST_ERROR,
      data: error,
    };
  }

}
